import { render, staticRenderFns } from "./SpaceBtn.vue?vue&type=template&id=95c7e14e&scoped=true&"
import script from "./SpaceBtn.vue?vue&type=script&lang=js&"
export * from "./SpaceBtn.vue?vue&type=script&lang=js&"
import style0 from "./SpaceBtn.vue?vue&type=style&index=0&id=95c7e14e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c7e14e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VTooltip})
